import React from 'react';
import config from 'react-global-configuration';
import c from 'classnames';
import {
  SearchkitWrapper,
  SearchStats,
  SearchPagination,
} from '@uncinc/react-searchkit';
import { DEFAULT_REQUEST_OPTIONS } from '@uncinc/react-searchkit/dist/config/constants';

import {
  resultAttributes,
  searchAttributes,
  highlightAttributes,
  sorting,
} from './config';

import {
  SEARCHKIT_HOST_URL,
  APP_OPTIONS,
} from '../../config/constants';

import SearchResults from './SearchResults';
import SearchBar from './SearchBar';

const SEARCH_ITEMS_PER_PAGE = 10;

const SearchAllContent = (props) => {
  const {
    className,
    children,
    routing = true,
    ...restProps
  } = props;

  const classNames = c('SearchAllContent', className);
  const requestOptions = {
    ...DEFAULT_REQUEST_OPTIONS,
  };

  // Only show KP content if on KP domain.
  if (config.get('CURRENT_DOMAIN') === 'kp') {
    requestOptions.getBaseFilters = () => [
      {
        bool: {
          must: {
            term: {
              field_domain_access: {
                value: config.get('CURRENT_DOMAIN_DRUPAL_IDENTIFIER'),
              },
            },
          },
        },
      },
    ];
  }

  return (
    <SearchkitWrapper
      {...restProps}
      className={classNames}
      connection={{ host: SEARCHKIT_HOST_URL }}
      indexName={APP_OPTIONS.parameters.searchkitIndexAllContent}
      routing={routing}
      hitsPerPage={SEARCH_ITEMS_PER_PAGE}
      searchSettings={{
        search_attributes: searchAttributes,
        result_attributes: resultAttributes,
        sorting,
        highlight_attributes: highlightAttributes,
      }}
      requestOptions={requestOptions}
    >
      {children}
    </SearchkitWrapper>
  );
};

SearchAllContent.SearchBar = SearchBar;
SearchAllContent.SearchStats = SearchStats;
SearchAllContent.SearchPagination = SearchPagination;
SearchAllContent.SearchResults = SearchResults;

export default SearchAllContent;
